import QrCodeIcon from "assets/menu-icons/QrCodeIcon";

const qrCode = {
  id: 'qrCode',
  type: 'group',
  restricted: true,
  children: [{
    id: 'qrCode',
    title: 'QR-код',
    type: 'item',
    url: '/qrCode',
    icon: QrCodeIcon,
    breadcrumbs: false,
    restricted: true,
  }]
}

export default qrCode;
